import PropTypes from "prop-types";
import React from "react";

import { getStoryDate } from "../../../utils";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import get from "lodash/get";

import "./liveblog-key-events.m.css";

const FetchEventTitle = (props) => {
  return (
    <div>
      {props.elements.map(
        (element, index) =>
          element.type === "title" && (
            <h3 data-testid="event-title" styleName="event-title" key={index}>
              {element.text}
            </h3>
          )
      )}
    </div>
  );
};
FetchEventTitle.propTypes = {
  elements: PropTypes.array,
};

const goToCard = (cardId) => {
  if (cardId) {
    setTimeout(() => {
      document.getElementById(cardId) &&
        document.getElementById(cardId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
    }, 100);
  }
};

const KeyEvent = (props) => {
  return (
    <div data-testid="key-events" styleName="key-events-wrapper" onClick={() => goToCard(props.card.id)}>
      <div>
        <div styleName="key-clock-wrapper clock-wrapper-key">
          <div styleName="key-event-clock">
            <SvgIconHandler width="24px" height="24px" type="clock" />
          </div>
          <div styleName="cards-added-at">{getStoryDate(props.card["card-added-at"])}</div>
        </div>
        <FetchEventTitle elements={props.card["story-elements"]} />
      </div>
    </div>
  );
};
KeyEvent.propTypes = {
  card: PropTypes.object,
  config: PropTypes.object,
  slug: PropTypes.string,
};

const LiveBlogKeyEvents = ({ story }) => {
  const cardsWithKeyEvents = story.cards.filter((card) => get(card.metadata, ["attributes", "key-event"]));
  if (cardsWithKeyEvents.length < 1) {
    return null;
  }
  const keyEvents = cardsWithKeyEvents.map((card) => (
    <KeyEvent card={card} key={`highlight-${card.id}`} slug={story.slug} />
  ));
  return (
    <div styleName="events">
      <div styleName="key-events event-styles-wrapper">
        <div styleName="heading">key events</div>
        {keyEvents}
      </div>
    </div>
  );
};
LiveBlogKeyEvents.propTypes = {
  story: PropTypes.object,
};

export { LiveBlogKeyEvents };
